import {downloadFileAPI} from '../../../utils';
import {BASE_URL} from '../../../utils/endpoints';
import {Button} from 'react-bootstrap';
import {useTranslation} from 'react-i18next';

interface OfferPdfDownloadButtonProps {
  offerId?: number;
  status?: string;
  label?: string;
  fileName?: string;
  className?: string;
  isZip?: boolean;
}

const DOWNLOADABLE_STATUSES = ['pending', 'negotiate', 'accepted', 'completed'];

export const OfferPdfDownloadButton = ({
                                         offerId,
                                         status,
                                         label,
                                         fileName = 'offer',
                                         className = 'btn-outline-primary',
                                         isZip = false,
                                       }: OfferPdfDownloadButtonProps) => {
  const {t} = useTranslation();

  if (!offerId || !DOWNLOADABLE_STATUSES.includes(status ?? '')) {
    return null;
  }

  const handleDownload = () => {
    const url = isZip
      ? `${BASE_URL}admin/offers/pdf/${offerId}/offer/zip`
      : `${BASE_URL}admin/offers/pdf/${offerId}/pdf`;

    downloadFileAPI(url, undefined, fileName);
  };

  return (
    <Button onClick={handleDownload} className={className}>
      {label ?? t('general.download')}
    </Button>
  );
};
